module.exports = __webpack_public_path__ + "static/img/placeholder.59e6f5b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/placeholders/placeholder.jpg
// module id = dUEC
// module chunks = 150